export default __webpack_public_path__ + "static/media/1-100.7bbc526f.jpg";